export default "__VITE_ASSET__DFYZPMbJ__"